import {VayuBlocksSelectControl, VayuBlocksBackground, VayuBlocksToggleControl} from '@vayu-blocks';
import { __ } from '@wordpress/i18n';
import { RangeControl } from '@wordpress/components';

const options = [
  { label: 'None ', value: 'none' },
  { label: 'Type 1  Glowing flower trail', value: 'MouseFollowerType1' },
  { label: 'Type 2  Petal drop effect', value: 'MouseFollowerType2' },
  { label: 'Type 3  Fading sparkles', value: 'MouseFollowerType3' },
  { label: 'Type 4  Rainbow flower drag', value: 'MouseFollowerType4' },
  { label: 'Type 5  Soft flower pulse', value: 'MouseFollowerType5' },
  { label: 'Type 6  Flower shadows', value: 'MouseFollowerType6' },
  { label: 'Type 7  Colored petal stream', value: 'MouseFollowerType7' },
  { label: 'Type 8  Flower glow wave', value: 'MouseFollowerType8' },
  { label: 'Type 9  Shadow bloom trail', value: 'MouseFollowerType9' },
  { label: 'Type 10  Floral particles', value: 'MouseFollowerType10' },
  { label: 'Type 11  Blooming motion', value: 'MouseFollowerType11' },
  // { label: 'Type 12  Magic flower orbit', value: 'MouseFollowerType12' },
  // { label: 'Type 13  circle', value: 'MouseFollowerType13' },
];

export const VayuBlocksMouseFollower = ({followerValue, onChange, datakey}) => {

  const handleChange = (value) => {
    const updatedValue = {
      ...followerValue,
      type:value
    }
    onChange(datakey, updatedValue);
  }

  const handlecursorChange = (value) => {
    const updatedValue = {
      ...followerValue,
      hideCursor:value
    }
    onChange(datakey, updatedValue);
  }

  const handleFollowerChange = (key, value) => {
    const updatedStyle = {
      ...followerValue.style,
      [followerValue.type]: {
        ...(followerValue.style?.[followerValue.type] || {}),
        [key]: value,
      },
    };

    const updatedValue = {
      ...followerValue,
      style: updatedStyle,
    };

    onChange(datakey, updatedValue);
  };

  return (
    <>
        <VayuBlocksSelectControl
          label={__('Mouse Follower', 'vayu-blocks')}
          value={followerValue?.type}
          options={options}
          onChange={(value) => handleChange(value)}
        />

        {followerValue?.type === 'MouseFollowerType1' && (
          <>
            <VayuBlocksBackground
              onChange={(key,value)=>handleFollowerChange('background',value)}
              colorPanel = {[
                {
                    active: ['gradient'],
                    label: 'Background',
                    key:'color',
                    value:followerValue?.style?.MouseFollowerType1?.background || '',
                },
              ]}
            />

            <RangeControl
              __nextHasNoMarginBottom={true}
              __next40pxDefaultSize = {true}
              label={__('Size', 'vayu-blocks')}
              max={ 50 }
              min={ 0 }
              marks
              step={5}
              value={ followerValue?.style?.MouseFollowerType1?.size }
              onChange={(value)=>handleFollowerChange('size',value)}
            />

          </>
        )}

        {followerValue?.type === 'MouseFollowerType2' && (
          <>
            <VayuBlocksBackground
              onChange={(key,value)=>handleFollowerChange('background',value)}
              colorPanel = {[
                {
                    active: ['gradient'],
                    label: 'Background',
                    key:'color',
                    value:followerValue?.style?.MouseFollowerType2?.background || '',
                },
              ]}
            />

            <RangeControl
              __nextHasNoMarginBottom={true}
              __next40pxDefaultSize = {true}
              label={__('Size', 'vayu-blocks')}
              max={ 50 }
              min={ 0 }
              marks
              step={5}
              value={ followerValue?.style?.MouseFollowerType2?.size }
              onChange={(value)=>handleFollowerChange('size',value)}
            />

          </>
        )}

        {followerValue?.type === 'MouseFollowerType3' && (
          <>
            <VayuBlocksBackground
              onChange={(key,value)=>handleFollowerChange('background',value)}
              colorPanel = {[
                {
                    active: ['gradient'],
                    label: 'Background',
                    key:'color',
                    value:followerValue?.style?.MouseFollowerType3?.background || '',
                },
              ]}
            />
          </>
        )}

        {followerValue?.type === 'MouseFollowerType4' && (
          <>
            <VayuBlocksBackground
              onChange={(key,value)=>handleFollowerChange('background',value)}
              colorPanel = {[
                {
                    active: ['gradient'],
                    label: 'Background',
                    key:'color',
                    value:followerValue?.style?.MouseFollowerType4?.background || '',
                },
              ]}
            />
          </>
        )}

        {followerValue?.type === 'MouseFollowerType5' && (
          <>
            <VayuBlocksBackground
              onChange={(key,value)=>handleFollowerChange('background',value)}
              colorPanel = {[
                {
                    active: ['gradient'],
                    label: 'Background',
                    key:'color',
                    value:followerValue?.style?.MouseFollowerType5?.background || '',
                },
              ]}
            />
          </>
        )}

        {followerValue?.type != 'none' && (
          <>
            <VayuBlocksToggleControl 
              label={__('Hide Cursor', 'vayu-blocks')}
              checked = {followerValue.hideCursor || false}
              onChange={(value) => handlecursorChange( value)}
            />
          </>
        )}
    
    </>
  )
}
